module.exports = __webpack_public_path__ + "static/img/edge_img_3.47b1bf9a.png";